import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from '../stores/Hooks';
import { StatementWarningPageRightBlock } from './RightBlock/StatementWarningPageRightBlock';

export const StatementWarningPage: React.FC<any> = observer(
	() =>
	{
		const { uiState, dataState } = useStores();

		function FormExistedInPast(): boolean
		{
			if (!dataState.Statement) return false;
			return dataState.Statement.FormTrigger;
		}

		return (
			<div className="row no-gutters scrolled-container">
				<div className="col-lg">
					<div className="info-on-mobile d-lg-none">
						<button
							className="text-primary text-center link d-flex align-items-center f-14"
							type="button"
							onClick={() => uiState.modal.ShowComponent("Информация по разделу", StatementWarningPageRightBlock)}
						>Информация по разделу <img src="./i/icons/question.svg" className="ml-2" alt="Информация по разделу" /></button>
					</div>
					<div className="statements-container">

						{(uiState.register.IsValid && uiState.info.IsValid && uiState.files.IsValid) &&
							<div className="statements-text">
								Уважаемый пользователь!<br />
								<br />
								Вам доступно формирование заявления оператора ЭДО. Сформированное заявление будет доступно для подписания и направления в ФНС России.<br />
								<br />
								Внимание! Проверьте правильность заполнения заявления. При указании некорректных сведений об организации или вложенных документах по результатам рассмотрения Вашего заявления ФНС России может быть принято отрицательное решение.<br />
								<br />
								Обратите внимание, что при изменении сведений об операторе ЭДО или приложенных документов сформированное заявление удалится из данного раздела.
							</div>
						}
						{((!uiState.register.IsValid || !uiState.info.IsValid || !uiState.files.IsValid) && !FormExistedInPast()) &&
							<div className="statements-text">
								Уважаемый пользователь!<br />
								<br />
								Обратите внимание, что все обязательные поля должны быть заполнены.<br />
								После этого возможно автоматически сформировать заявление и
								подписать его квалифицированной электронной подписью руководителя
								(действующего от имени организации без доверенности) оператора ЭДО.
							</div>
						}
						{((!uiState.register.IsValid || !uiState.info.IsValid || !uiState.files.IsValid) && FormExistedInPast()) &&
							<div className="statements-text">
								Уважаемый пользователь!<br />
								<br />
								Данные изменились, заявление необходимо сформировать повторно. <br />
								Обратите внимание, что все обязательные поля должны быть заполнены.
								После этого возможно автоматически сформировать заявление оператора ЭДО
								и подписать его квалифицированной электронной подписью руководителя организации
								(действующего от имени организации без доверенности) оператора ЭДО
							</div>
						}
					</div>
				</div>
				<div className="col-lg-auto sidebar d-none d-lg-block">
					<StatementWarningPageRightBlock />
				</div>
			</div>
		);
	}
)
